// extracted by mini-css-extract-plugin
var _1 = "ra-placeholder-animated";
var _2 = "ra-placeholder-base-16x9";
var _3 = "ra-placeholder-base-4x3";
var _4 = "ra-placeholder-base";
var _5 = "ra-placeholder";
var _6 = "ra-placeholder-text";
export { _1 as "placeholderAnimatedCls", _2 as "placeholderBase16x9Cls", _3 as "placeholderBase4x3Cls", _4 as "placeholderBaseCls", _5 as "placeholderCls", _6 as "placeholderTextCls" }
